const styles = (theme) => ({
  itemsContainer: {
    display: 'grid',
    justifyItems: 'start',
    padding: theme.spacing(1),
  },
})

export default styles
